import * as React from 'react'
import {Form, Modal, notification, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectMemberItem, NewProjectMemberStore} from 'src/stores/projectmembers-store';
import {connect} from 'redux-scaffolding-ts'
import autobind from 'autobind-decorator';
import {DropDownEmployeesStore} from '../../../../stores/employees-store';
import {ItemReference, QueryResult} from '../../../../core/stores/dataStore';

let FormItem = Form.Item;

interface CreateAllMemberViewProps {
    companyId: string,
    projectId: string,
    visible: boolean,
    onClose: (id: string | undefined, item?: NewProjectMemberItem) => void;
    onRefreshRequired?: () => void
}

interface CreateAllMemberViewState {
    newEmployeesList: QueryResult<ItemReference>;
    confirmed: boolean;
    isBusy?: boolean;
}

@connect(["newProjectMember", NewProjectMemberStore], ["dropdownemployees", DropDownEmployeesStore])
class CreateAllMemberView extends React.Component<CreateAllMemberViewProps & WithTranslation & FormComponentProps, CreateAllMemberViewState> {

    private get newProjectMemberStore() {
        return (this.props as any).newProjectMember as NewProjectMemberStore;
    }

    private get employeesStore() {
        return (this.props as any).dropdownemployees as DropDownEmployeesStore;
    }

    constructor(props: CreateAllMemberViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.employeesStore.changeUrl(props.companyId);
        this.newProjectMemberStore.changeUrl(this.props.companyId, this.props.projectId);
        this.state = {
            newEmployeesList: { items: [], count: 0 },
            confirmed: false
        }
    }

    componentWillMount() {
        this.setState({ isBusy:true })
        this.getEmployees().then(result => {
            this.setState({ isBusy: false, newEmployeesList: result })
        })

    }

    componentWillUpdate(nextProps: CreateAllMemberViewProps) {
        if (nextProps.visible != this.props.visible) {
            this.setState({ isBusy: true, newEmployeesList: { items: [], count: 0 }, confirmed: false })
            this.getEmployees().then(result => {
                this.setState({ isBusy: false, newEmployeesList: result })
            })
        }
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private async getEmployees(): Promise<QueryResult<ItemReference>> {
        var result = await this.employeesStore.getAllAsync({
            searchQuery: "",
            skip: 0,
            parameters: {
                "excludeProjectMembers": this.props.projectId
            },
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }],
            take: 1000
        } as any) || { count: 0, items: [] };

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.id}`,
                title: `${o.title}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    @autobind
    private async onConfirmed() {
        const { t } = this.props
        if (this.state.newEmployeesList.items.length == 0)
            return this.onClose()
        
        this.setState({ confirmed: true })
        let newMemberItem = { projectId: this.props.projectId, employeeId: this.state.newEmployeesList.items.map(x => x.id), permission: 1 }
        this.newProjectMemberStore.createNew(newMemberItem);
        return new Promise((resolve, reject) => {
            this.newProjectMemberStore.submit().then(result => {
                if (result.isSuccess) {
                    if (this.props.onRefreshRequired) {
                        this.props.onRefreshRequired()
                    }
                    resolve();
                    this.countDownNotification(notification.success, t("Notification"), this.state.newEmployeesList.items.length + " " + t("Project members successfully added"), "succes")
                    this.onClose(result.identifier)
                } else {
                    reject();
                    this.countDownNotification(notification.error, t("Error"), t("There was an error adding project members"), "fail")
                }
            })
        }) 
    }
    
    @autobind
    private onClose(id?: string) {
        this.newProjectMemberStore.clear();
        this.props.onClose(id);
    }

    @autobind
    private onCancel() {
        this.newProjectMemberStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;
        
        return (
            <Modal
                maskClosable={false}
                visible={this.props.visible}
                onCancel={this.onCancel}
                onOk={this.onConfirmed}
                closable={false}
                width='800px'
                okText={t("OK")}
                cancelText={t("Cancel")}
                title={t("Add all available employees")}>
                <Spin spinning={this.newProjectMemberStore.state.isBusy}>
                    <div>
                        {this.state.newEmployeesList.items.length.toString() + " " + t("employees will be added to project")}
                    </div>
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(CreateAllMemberView as any) as any) as any as React.ComponentClass<CreateAllMemberViewProps>;